import React from 'react'
import { Label, StyledFormItem } from './styled'

const FormItem = props => (
  <StyledFormItem>
    <Label>{props.label}</Label>
    {props.children}
  </StyledFormItem>
)

export default FormItem



// WEBPACK FOOTER //
// ./src/components/FormItem/index.js